import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import theme from './theme/theme';
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import HighlightsSection from './components/HighlightsSection/HighlightsSection';
import AboutSection from './components/AboutSection/AboutSection';
import CourseOverview from './components/CourseOverview/CourseOverview';
import BannerSection from './components/BannerSection/BannerSection';
import Familia from './components/Familia/Familia';
import FAQSection from './components/FAQSection/FAQSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import CTASection from './components/CTASection/CTASection';
import AnimationSection from './components/AnimationSection/AnimationSection';
import FinalCTASection from './components/FinalCTASection/FinalCTASection';
import Footer from './components/Footer/Footer';
import VisionMission from './pages/VisionMission/page';
import LaFinca from './pages/LaFinca/page';
import QuienesSomos from './pages/QuienesSomos/page';
import PersonDetail from './pages/PersonDetail/page';
import Cursos from './pages/Cursos/page';
import CourseDetail from './pages/CourseDetail/page';
import NoticiasBlog from './pages/NoticiasBlog/page';
import BlogDetail from './pages/BlogDetail/page';
import Contact from './components/Contact/Contact';
import CourseRegistration from './components/CourseRegistration/CourseRegistration';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { TranslationProvider } from './context/TranslationContext';
import NotFound from './pages/NotFound/NotFound';


const createEmotionCache = () => {
  return createCache({
    key: "mui",
    prepend: true,
  });
};

const emotionCache = createEmotionCache();

const HomePage: React.FC = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <AboutSection />
      <HighlightsSection />
      <CourseOverview />
      <BannerSection />
      <Familia />
      <FAQSection />
      <CTASection />
      
      
      <FinalCTASection />
      
      <Footer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <TranslationProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/mission-vision" element={<VisionMission />} />
              <Route path="/la-finca" element={<LaFinca />} />
              <Route path="/quienes-somos" element={<QuienesSomos />} />
              <Route path="/equipo/:slug" element={<PersonDetail />} />
              <Route path="/cursos" element={<Cursos />} />
              <Route path="/cursos/:slug" element={<CourseDetail />} />
              <Route path="/noticias-blog" element={<NoticiasBlog />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/registro-curso" element={<CourseRegistration />} />
              <Route path="/404-not-found" element={<NotFound />} />
              <Route path="/:slug" element={<BlogDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </TranslationProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default App;